/*
 * 文件EN: EchartsApiSucc.vue,
 * 文件CN: 各类API每天成功调用览表,
 * 创建时间: Tuesday, 16th June 2020 4:17:08 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
<template>
  <div class="relative">
    <div
      class="legends absolute flex-box"
      :style="{ top: `${-20}px`, right: 0 }"
    >
      <template v-for="(item, index) in legendData">
        <div
          class="cur-pointer flex-box flex-align-center"
          :style="{ display: `inline-block`, marginRight: `${15}px` }"
          :key="index"
          @click="
            item.selected
              ? legendUnSelect(item, item.name)
              : legendSelect(item, item.name)
          "
        >
          <span
            class="legends-symbol"
            :style="{ background: `${item.selected ? item.color : '#ccc'}` }"
          ></span>
          <span
            class="flex-item legends-label"
            :style="{ color: item.selected ? '' : '#ccc' }"
            >{{ item.name }}</span
          >
        </div>
      </template>
    </div>
    <div ref="echarts-main" style="min-height:400px">暂无数据</div>
  </div>
</template>

<script>
export default {
  props: ['api_key'],
  components: {},
  data() {
    return {
      // 实例的节点名
      className: 'echarts-main',
      // 实例
      myChart: {},
      // 配置项
      options: {},
      // x轴类目
      xAxisData: [
        '0-2',
        '3-4',
        '5-6',
        '7-8',
        '9-10',
        '11-12',
        '13-14',
        '15-16',
        '17-18',
        '19-20',
        '21-22',
        '23-24'
      ],
      // 类目
      legendData: [
        { name: '通讯类', color: 'rgba(60, 227, 193, 1)', selected: true },
        { name: '司法类', color: 'rgba(237, 0, 0, 1)', selected: true },
        { name: '征信类', color: 'rgba(247, 234, 0, 1)', selected: true },
        { name: '运营类', color: 'rgba(118, 213, 0, 1)', selected: true },
        { name: '财务类', color: 'rgba(70, 140, 228, 1)', selected: true }
      ]
    }
  },
  watch: {
    // 监听条件查询是否改变
    api_key(val) {
      this.initData()
    },
    // 监听options是否配置完成
    options(o) {
      JSON.stringify(o) !== '{}' && this.myChart.setOption(o)
    }
  },
  async mounted() {
    // 绑定监听事件 窗口变化
    window.addEventListener('resize', this.resizeHandler)
    // 通过hook监听组件销毁钩子函数，并取消监听事件
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.resizeHandler)
    })
    // 获取数据
    this.initData()
  },
  methods: {
    // echarts尺寸自适应
    resizeHandler() {
      // Echarts 的 resize 方法 自适应窗口
      // JSON.stringify(this.myChart) !== '{}' && this.myChart.resize()
      window.onresize = () => {
        if (this.myChart.hasOwnProperty('resize')) {
          this.myChart.resize()
        }
      }
    },
    // 初始化echarts需要的options
    async initOpt() {
      const { legendData, seriesData, xAxisData } = this

      this.options = {
        // 提示框组件
        tooltip: {
          // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          trigger: 'axis',
          // 坐标轴指示器配置项。
          axisPointer: {
            lineStyle: {
              color: 'rgba(0, 0, 0,0.1)'
            }
          }
        },
        // 区域缩放
        dataZoom: [
          {
            // 鼠标滚动
            type: 'inside'
          }
        ],
        legend: {
          show: false,
          data: legendData.reduce((prev, elem) => prev.concat(elem.name), [])
        },
        xAxis: {
          name: '计算日期',
          nameLocation: 'start', // 坐标轴名称显示位置
          nameTextStyle: {
            color: 'rgba(237, 0, 0, 1)'
          },
          // 两边留白策略
          boundaryGap: false, // false为从0刻度开始 不留白
          data: xAxisData,
          axisLabel: { color: 'rgba(100, 100, 100, 1)' },
          axisLine: { lineStyle: { color: 'rgba(0, 0, 0,0.1)' } },
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          boundaryGap: false,
          axisLabel: { color: 'rgba(100, 100, 100, 1)' },
          axisLine: { lineStyle: { color: 'rgba(0, 0, 0,0.1)' } },
          axisTick: { show: false },
          splitLine: { show: false }
        },
        grid: {
          x: 80,
          y: 30,
          x2: 80,
          y2: 30 // 80,
        },
        symbol: 'none',
        series: seriesData
      }
    },
    // 初始化echarts的实例
    initEcharts() {
      const { className, $nextTick, initOpt } = this
      echarts.init(this.$refs[className]).dispose() // 销毁前一个实例
      this.myChart = echarts.init(this.$refs[className]) // 创建个新的实例
      $nextTick(function() {
        initOpt()
      })
    },
    // 选中图例。
    legendSelect(item, name) {
      item.selected = true
      this.myChart.dispatchAction({
        type: 'legendToggleSelect',
        // 图例名称
        name: name
      })
    },
    // 取消选中图例。
    legendUnSelect(item, name) {
      item.selected = false
      this.myChart.dispatchAction({
        type: 'legendUnSelect',
        // 图例名称
        name: name
      })
    },
    // 获取数据
    async initData() {
      this.genData()
      const {
        $store: { dispatch },
        legendData
      } = this
      await dispatch('T9/APIAnalyze/queryApiSuccState', {
        type: this.api_key
      }).then(res => {
        // let xad = []
        this.xAxisData = []
        this.seriesData = []
        res.map((item, index) => {
          item.color = this.legendData.filter(
            elem => elem.name === item.name
          )[0].color
          item.list.map(data => {
            // 如果x轴不存在当前类目
            if (this.xAxisData.indexOf(data.invokeTime) === -1) {
              this.xAxisData.push(data.invokeTime)
            }
          })
        })

        res.map((item, index) => {
          let data = item.list.reduce((pre, ele) => {
            pre.push([ele.invokeTime, ele.invokeCount])
            return pre
          }, [])
          let dataTimes = data.reduce((p, e) => p.concat(e[0]), [])
          // 如果seriesData的数量和x轴的类目数量不一致，则补充没有的x轴为0
          if (data.length !== this.xAxisData.length) {
            this.xAxisData.map(time => {
              // 如果没有该时间
              if (dataTimes.indexOf(time) === -1) {
                // 给0
                data.push([time, 0])
              }
            })
          }
          this.seriesData.push({
            name: item.name,
            type: 'line',
            smooth: true, // 曲线平滑
            data: data,
            symbol: 'circle', // 设定为实心点
            showSymbol: false,
            itemStyle: {
              normal: {
                // 折线与x轴的面积颜色
                areaStyle: {
                  type: 'default',
                  // 渐变色实现
                  color: item.color,
                  opacity: 0.3
                },
                // 小圆点颜色
                color: item.color,
                // 折线颜色
                lineStyle: {
                  color: item.color
                },
                label: {
                  show: true,
                  color: '#505050',
                  position: 'top',
                  formatter: function(param) {
                    return param.data.label
                  },
                  textStyle: {
                    fontWeight: 'bolder',
                    fontSize: '12'
                  }
                }
              }
            }
          })
        })

        this.$nextTick(() => {
          // 初始化echarts的实例
          this.initEcharts()
        })
      })
    },
    // 测试
    async genData(count) {
      const { xAxisData, legendData } = this
      this.seriesData = []
      legendData.map(item => {
        this.seriesData.push({
          name: item.name,
          type: 'line',
          smooth: true, // 曲线平滑
          data: xAxisData.reduce(
            (prev, elem) =>
              prev.concat(parseInt(Math.random() * (30 - 1 + 1) + 1, 10)),
            []
          ),
          symbol: 'circle', // 设定为实心点
          showSymbol: false,
          itemStyle: {
            normal: {
              // 折线与x轴的面积颜色
              areaStyle: {
                type: 'default',
                // 渐变色实现
                color: item.color,
                opacity: 0.3
              },
              // 小圆点颜色
              color: item.color,
              // 折线颜色
              lineStyle: {
                color: item.color
              },
              label: {
                show: true,
                color: '#505050',
                position: 'top',
                formatter: function(param) {
                  return param.data.label
                },
                textStyle: {
                  fontWeight: 'bolder',
                  fontSize: '12'
                }
              }
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.legends-symbol {
  width: 26px;
  height: 15px;
  border-radius: 3px;
}
.legends-label {
  font-size: 12px;
  margin-left: 5px;
}
</style>
